import { render, staticRenderFns } from "./CardInput.vue?vue&type=template&id=5bfbf6ef&scoped=true&lang=pug&"
import script from "./CardInput.vue?vue&type=script&lang=js&"
export * from "./CardInput.vue?vue&type=script&lang=js&"
import style0 from "./CardInput.vue?vue&type=style&index=0&id=5bfbf6ef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbf6ef",
  null
  
)

export default component.exports